import { z } from "zod";
//#region src/index.ts
var zodValidator = (options) => {
	const input = "input" in options ? options.input : "input";
	const output = "output" in options ? options.output : "output";
	const _input = "schema" in options ? options.schema._input : options._input;
	const _output = "schema" in options ? options.schema._output : options._output;
	return {
		types: {
			input: input === "output" ? _output : _input,
			output: output === "input" ? _input : _output
		},
		parse: (input) => "schema" in options ? options.schema.parse(input) : options.parse(input)
	};
};
var fallback = (schema, fallback) => {
	return z.custom().pipe(schema.catch(fallback));
};
//#endregion
export { fallback, zodValidator };

//# sourceMappingURL=index.js.map